import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

import { ReflexContainer, ReflexElement } from "react-reflex";
import "react-reflex/styles.css";

import { countLogsPerHour, escapeRegExp, strCurrentDay, strDate, strDateMinusOne, strDatePlusOne } from "../../common/utils/helperFunctions";

// date-fns
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { fr } from "date-fns/locale/fr";

import Spinner from "../../common/components/spinner/Spinner";

import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Button, Grid, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";

import { authSelector } from "../auth/authSlice";

import { usePostGetLogsByParamsMutation } from "../../app/services/backendApi";

import { useCreateLogMutation } from "../../app/services/backendApi";

import ClearIcon from "@mui/icons-material/Clear";
import FilterListIcon from "@mui/icons-material/FilterList";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import SearchIcon from "@mui/icons-material/Search";

import { ENV } from "../../common/utils/apiConstants";

import ChartLogs from "../../common/components/chartLogs/ChartLogs";

import { addToListLevels, addToListServices, clearListLevels, clearListServices, displaySelector, setCount, setStartResearch } from "../display/displaySlice";

import { DatePicker } from "@mui/x-date-pickers";

import TextField from "@mui/material/TextField";
import ToolsbarGraph from "../../common/components/toolsbar/ToolsBarGraph";

import styles from "../../styles/storedLog.module.css";
/* ------------------------------------------------------------------------- */

const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: "top"
    },

    title: {
      display: false,
      text: strCurrentDay()
    }
  }
};

// Returns the index of the value if it exists, or undefined if not
// eslint-disable-next-line no-extend-native
Object.defineProperty(Object.prototype, "associativeIndexOf", {
  value: function (value) {
    for (var key in this) if (this[key] === value) return key;
    return undefined;
  }
});
/* ----------------------------------------------------------------------- */

const StoredLog = () => {
  const auth = useSelector(authSelector);
  const display = useSelector(displaySelector);
  const dispatch = useDispatch();

  const [logFetched, setLogFetched] = useState(false);
  const [selectedDay, setSelectedDay] = useState(strCurrentDay());
  // - Data to get for DataGrid -
  //const { data, isFetching, isError, error, isLoading } = useGetAllLogsQuery();

  // - Data for Chart -
  // const logsCurrentDay = useGetLogsCurrentDayQuery();
  // const [triggerSearchLogs, result] = middleware.endpoints.getLogsBySelectedDay.useLazyQuery();

  const [triggerSearchByParams, result] = usePostGetLogsByParamsMutation();
  /* ----------------------------------------------------------------------- */

  const labels = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"];

  /**
   * function called when
   * - onClick on JOUR PRECEDENT button
   * - onClick on JOUR SUIVANT button
   * - isDisplayGraph is true
   *
   */
  const getLogsByParams = async (day) => {
    setSelectedDay(day);
    //triggerSearchLogs(day)

    let servicesFilter = [];
    display.listServices.forEach((item) => {
      servicesFilter.push(item.app);
    });

    let levelsFilter = [];
    display.listLevels.forEach((item) => {
      levelsFilter.push(item.lvl);
    });
  };
  /* ----------------------------------------------------------------------- */
  // - handling for log notification
  let errorInfos = {
    environment: ENV,
    userEmail: auth.user.email,
    code: 400,
    criticite: 3
  };
  const [triggerLog] = useCreateLogMutation();
  /* ----------------------------------------------------------------------- */

  const [dateDeb, setDateDeb] = useState(new Date());
  const [dateFin, setDateFin] = useState(new Date());
  const [openDatesPeriod, setOpenDatesPeriod] = useState(true);

  const toggleDates = () => {
    setOpenDatesPeriod(!openDatesPeriod);
  };

  const handleChangeDateDeb = (newValue) => {
    setDateDeb(newValue);
  };

  const handleChangeDateFin = (newValue) => {
    setDateFin(newValue);
  };

  const [openCritList, setOpenCritList] = useState(true);
  const toggleCriticite = () => {
    setOpenCritList(!openCritList);
  };

  const [openServiceList, setOpenServiceList] = useState(true);
  const toggleServices = () => {
    setOpenServiceList(!openServiceList);
  };

  const serviceLinks = Object.values(display.existingServices);

  /**
   * Initialisation: si la carte d'un service a été cliquée sur la page d'accueil
   * alors la case à cocher du service est cochée automatique; le service
   * apparaît dans le state redux, dans display.listServices
   */
  const initCheckedServices = () => {
    let list = [];
    display.listServices.forEach((serv) => {
      let intValue = parseInt(serviceLinks.associativeIndexOf(serv.app));
      list.push(intValue);
    });
    return list;
  };

  const [checkedServices, setCheckedServices] = useState(initCheckedServices());

  const critLinks = {
    0: 1,
    1: 2,
    2: 3
  };

  /**
   * Initialisation: Si la carte d'un service a été cliquée sur la page d'accueil,
   * alors en fonction de l’état de ce service, la case à cocher du niveau de criticite
   * correspondante est cochée
   */
  const initCheckedCriticities = () => {
    let list = [];
    display.listLevels.forEach((crit) => {
      let intValue = parseInt(critLinks.associativeIndexOf(crit.lvl));
      list.push(intValue);
    });
    return list;
  };

  const [checkedCrit, setCheckedCrit] = useState(initCheckedCriticities());

  /** -------------------------------------------------------------------------
   * Filter logs return by lireLogsParCriteres, put in result.data.logs
   * depends on checked services and/or crit levels
   * ----------------------------------------------------------------------- */
  const filterRows = (selectedServ, selectedCrit) => {
    if (result.data !== undefined) {
      let filteredRows = [];
      filteredRows = result.data.logs.filter((dataLog) => selectedServ.some((serv) => serv.toLowerCase() === dataLog.service.toLowerCase()));
      if (selectedCrit.length > 0) {
        filteredRows = filteredRows.filter((dataLog) => selectedCrit.includes(dataLog.criticite));
      }
      setRows(filteredRows);
    }
  };

  /** -------------------------------------------------------------------------
   * - Handling clic a checkbox service
   * ----------------------------------------------------------------------- */
  const handleClickCheckboxService = async (value) => {
    const currentIndex = checkedServices.indexOf(value);

    const newCheckedService = [...checkedServices];

    if (currentIndex === -1) {
      newCheckedService.push(value);
    } else {
      newCheckedService.splice(currentIndex, 1);
    }

    setCheckedServices(newCheckedService);
    dispatch(clearListServices());

    let servicesFilter = [];
    newCheckedService.forEach((item) => {
      let service = serviceLinks[item];
      servicesFilter.push(service);
      dispatch(addToListServices(service));
    });

    let levelsFilter = [];
    checkedCrit.forEach((item) => {
      levelsFilter.push(item + 1);
    });

    // - Ajout criticité supérieure à 3
    if (levelsFilter.includes(3)) {
      levelsFilter.push(4);
      levelsFilter.push(5);
    }

    filterRows(servicesFilter, levelsFilter);
  };

  /** -------------------------------------------------------------------------
   * - Handling clic a checkbox criticality
   * ----------------------------------------------------------------------- */
  const handleClickCheckboxCrit = async (value) => {
    const currentIndex = checkedCrit.indexOf(value);
    const newCheckedCrit = [...checkedCrit];

    if (currentIndex === -1) {
      newCheckedCrit.push(value);
    } else {
      newCheckedCrit.splice(currentIndex, 1);
    }
    setCheckedCrit(newCheckedCrit);

    dispatch(clearListLevels());

    let levelsFilter = [];
    newCheckedCrit.forEach((item) => {
      let crit = critLinks[item];
      levelsFilter.push(crit);

      // - Ajout criticité supérieure à 3
      if (parseInt(crit) === 3) {
        levelsFilter.push(4);
        levelsFilter.push(5);
      }
      dispatch(addToListLevels(crit));
    });

    let servicesFilter = [];
    checkedServices.forEach((item) => {
      let service = serviceLinks[item];
      servicesFilter.push(service);
    });

    filterRows(servicesFilter, levelsFilter);
  };

  /** -------------------------------------------------------------------------
   * - Definitions for the DataGrid in bottom of page
   * ----------------------------------------------------------------------- */
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);

  const columns = [
    {
      field: "id",
      headerName: "Id",
      renderCell: (params) => (
        <>
          <div className={styles.idContent}>{params.value}</div>
        </>
      ),
      headerClassName: "tableHeader",
      cellClassName: `${styles.idCell}`,
      flex: 0.6,
      minWidth: 100,
      maxWidth: 100,
      headerAlign: "center",
      align: "center"
    },
    {
      field: "created_at",
      headerName: "Date",
      renderCell: (params) => (
        <>
          <div className={styles.dPart}>{params.value.substring(0, 10)}</div>
          <div className={styles.hPart}>{params.value.substring(11, 19)}</div>
        </>
      ),
      headerClassName: "tableHeader",
      cellClassName: `${styles.dateCell}`,
      flex: 1,
      minWidth: 100,
      maxWidth: 100,
      headerAlign: "center",
      align: "left",
      type: "date",
      valueFormatter: (params) => params
    },
    {
      field: "message",
      headerName: "",
      sortable: false,
      renderCell: (params) => (
        <>
          <div className={styles.msgContent}>{params.value}</div>
        </>
      ),
      headerClassName: "tableHeader",
      cellClassName: `${styles.msgCell}`,
      flex: 1,
      minWidth: 580,
      headerAlign: "center",
      align: "left"
    },
    {
      field: "criticite",
      headerName: "",
      sortable: false,
      renderCell: (params) => (
        <>
          {params.value === 1 && <div className={styles.usageIco}>info</div>}
          {params.value === 2 && <div className={styles.alertIco}>alerte</div>}
          {params.value >= 3 && <div className={styles.errorIco}>erreur</div>}
        </>
      ),
      headerClassName: "tableHeader",
      cellClassName: `${styles.critCell}`,
      flex: 1,
      minWidth: 80,
      maxWidth: 80,
      headerAlign: "center",
      align: "center"
    }
  ];

  /* ----------------------------------------------------------------------- */
  const [searchText, setSearchText] = useState("");

  /* - handling selected row - */
  const [selectedRow, setSelectedRow] = useState(null);
  const [selection, setSelection] = useState([]);

  /* - handling research filter */
  const [rows, setRows] = useState([]);

  const [chartData, setChartData] = useState(null);

  /* --------------------------------------------------------------------------
   * - Initialisation pour le graph
   * ----------------------------------------------------------------------- */
  function initChartData() {
    let emptyArray = [];
    let dataPerHour = countLogsPerHour(emptyArray, selectedDay);
    let dataGraph = {
      labels,
      datasets: [
        {
          label: "log",
          data: dataPerHour,
          backgroundColor: "rgba(53, 162, 235, 0.5)"
        }
      ]
    };
    setChartData(dataGraph);
  }

  /* --------------------------------------------------------------------------
   * useEffect() definitions
   * just after componentDidMount
   * Regle: si aucun service selectionné == sur le lien Espace monitoring
   * alors pas de recherche inutile, aucun logs retourné
   * ----------------------------------------------------------------------- */
  useEffect(() => {
    if (display.startResearch === true) {
      dispatch(setStartResearch(false));
      initChartData();

      let tabListServices = [];
      display.listServices.forEach((item) => {
        tabListServices.push(item.app);
      });

      let tabListCrit = [];
      display.listLevels.forEach((item) => {
        tabListCrit.push(parseInt(item.lvl));
      });
      // - Ajout criticité supérieure à 3
      if (tabListCrit.includes(3)) {
        tabListCrit.push(4);
        tabListCrit.push(5);
      }

      if (tabListServices.length !== 0) {
        let body = {
          dateTime: selectedDay,
          listServices: tabListServices,
          listLevels: tabListCrit,
          dateDeb: strDate(dateDeb),
          dateFin: strDate(dateFin)
        };

        let bodyParam = encodeURIComponent(JSON.stringify(body));
        triggerSearchByParams(bodyParam);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [display.startResearch]);

  useEffect(() => {
    if (display.count === true) {
      dispatch(setCount(false));
      initChartData();

      let tabListServices = [];
      display.listServices.forEach((item) => {
        tabListServices.push(item.app);
      });

      let tabListCrit = [];
      display.listLevels.forEach((item) => {
        tabListCrit.push(item.lvl);
      });

      if (tabListServices.length !== 0) {
        handleChangeDateDeb(strDateMinusOne(dateDeb));
        let body = {
          dateTime: selectedDay,
          listServices: tabListServices,
          listLevels: tabListCrit,
          dateDeb: strDateMinusOne(dateDeb),
          dateFin: strDate(dateFin)
        };

        let bodyParam = encodeURIComponent(JSON.stringify(body));
        triggerSearchByParams(bodyParam);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [display.count]);

  /* --------------------------------------------------------------------------
   * Handling result of triggerSearchByParams(bodyParam),the call api service
   * lireLogsParCriteres
   * ----------------------------------------------------------------------- */
  useEffect(() => {
    if (result.isSuccess && result.status === "fulfilled" && result.data.hasOwnProperty("logs")) {
      setLogFetched(true);

      let dataPerHour = countLogsPerHour(result.data.logs, selectedDay);
      let dataGraph = {
        labels,
        datasets: [
          {
            label: "log",
            data: dataPerHour,
            backgroundColor: "rgba(53, 162, 235, 0.5)"
          }
        ]
      };
      setChartData(dataGraph);

      //setRows(result.data.logs);

      let servicesFilter = [];
      display.listServices.forEach((item) => {
        servicesFilter.push(item.app);
      });

      let levelsFilter = [];
      display.listLevels.forEach((item) => {
        levelsFilter.push(item.lvl);
      });

      if (levelsFilter.includes(3)) {
        levelsFilter.push(4);
        levelsFilter.push(5);
      }

      filterRows(servicesFilter, levelsFilter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.data]);
  /* ----------------------------------------------------------------------- */

  useEffect(() => {
    if (result.isError) {
      errorInfos.className = "StoredLog.js::usePostGetLogsByParamsMutation()";

      const genericMessage = "An error occured";
      let sourceMsg = result.error?.data?.errors[0].detail ? result.error.data.errors[0].detail : genericMessage;
      errorInfos.message = "Echec lors de la récuperation des logs - " + sourceMsg;
      triggerLog(errorInfos);

      let displayErrorMessage = "Echec lors de la récuperation des logs";

      if (result.error?.status === 401) {
        displayErrorMessage = "Accès refusé";
      }
      toast.error(
        <>
          <span>{displayErrorMessage}</span>
        </>,
        {
          duration: 10000
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.isError]);

  /* --------------------------------------------------------------------------
   * - Handling display or hide graph block
   * ----------------------------------------------------------------------- */
  useEffect(() => {
    getLogsByParams(selectedDay);

    var element = document.getElementById("graphId");
    //var mainElem = document.getElementById("mainId");
    if (display.isDisplayGraph) {
      if (element != null) {
        element.style.display = "block";
        //mainElem.style.marginLeft = '280px';
      }
    } else {
      if (element != null) {
        element.style.display = "none";
        //mainElem.style.marginLeft = '0px';
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [display.isDisplayGraph]);
  /* ----------------------------------------------------------------------- */

  if (result.isFetching || rows === undefined) {
    return <></>;
  }

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
    const filteredRows = result.data.logs.filter((data) => {
      return Object.keys(data).some((field) => {
        return data[field] !== null && searchRegex.test(data[field].toString());
      });
    });
    setRows(filteredRows);
  };

  /* ----------------------------------------------------------------------- */
  return (
    <Box sx={{ flexGrow: 1 }} className={styles.boxContent}>
      <ToolsbarGraph />

      <div id="graphId" className={styles.graphBlock}>
        <Grid container justifyContent="center" alignItems="center" className={styles.chartBar}>
          <Grid item xs={2}>
            <Button variant="outlined" onClick={() => getLogsByParams(`${strDateMinusOne(selectedDay)}`)} className={styles.chartButton}>
              Jour précédent
            </Button>
          </Grid>
          <Grid item xs={8} className={styles.txtCenter}>
            <span className={styles.labelDate}>Affichage des logs du {selectedDay}</span>
          </Grid>
          <Grid item xs={2} className={styles.txtRight}>
            <Button variant="outlined" onClick={() => getLogsByParams(`${strDatePlusOne(selectedDay)}`)} className={styles.chartButton}>
              Jour suivant
            </Button>
          </Grid>
        </Grid>
        me
        <div className={styles.chartContainer}>{logFetched === true && <ChartLogs options={chartOptions} data={chartData} />}</div>
      </div>

      <Grid container spacing={2} className={styles.mainContent}>
        <Grid item xs={12} className={styles.noPadding}>
          <ReflexContainer orientation="vertical">
            <ReflexElement minSize={250} size={300} className={styles.filtersBlock}>
              <div>
                <div className={styles.blockFilterHeader}>
                  <h3>
                    <FilterListIcon className={styles.adjustPos} />
                    Filtres{" "}
                  </h3>
                </div>
                <div>
                  <List
                    sx={{
                      width: "100%",
                      maxWidth: 900,
                      bgcolor: "background.paper"
                    }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={<ListSubheader component="div" id="nested-list-subheader"></ListSubheader>}
                    className={styles.listFilters}
                  >
                    <ListItemButton onClick={() => toggleDates()} className={styles.pd4}>
                      <ListItemText primary={`Période`} className={styles.sectionFilters} />
                      {openDatesPeriod ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>

                    <Collapse in={openDatesPeriod} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                          <ListItem>
                            <DatePicker label="Date de début" className={styles.customDatePicker} format="dd/MM/yyyy" value={dateDeb} onChange={handleChangeDateDeb} slotProps={{ textField: { className: styles.customDatePicker } }} />
                          </ListItem>

                          <ListItem>
                            <DatePicker label="Date de fin" className={styles.customDatePicker} format="dd/MM/yyyy" value={dateFin} onChange={handleChangeDateFin} slotProps={{ textField: { className: styles.customDatePicker } }} />
                          </ListItem>
                        </LocalizationProvider>
                      </List>
                    </Collapse>

                    <ListItemButton onClick={() => toggleServices()} className={styles.pd4}>
                      <ListItemText primary={`Service (${display.existingServices.length})`} className={styles.sectionFilters} />
                      {openServiceList ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openServiceList} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {serviceLinks.map((value, index) => {
                          const labelIdService = `checkbox-list-label-${index}`;
                          return (
                            <ListItem key={index} disablePadding>
                              <ListItemButton role={undefined} onClick={() => handleClickCheckboxService(index)} className={styles.nestedList}>
                                <ListItemIcon className={styles.customCheckBox}>
                                  <Checkbox
                                    edge="start"
                                    checked={checkedServices.indexOf(index) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                      "aria-labelledby": labelIdService
                                    }}
                                  />
                                </ListItemIcon>
                                <ListItemText id={labelIdService} primary={value} />
                              </ListItemButton>
                            </ListItem>
                          );
                        })}
                      </List>
                    </Collapse>

                    <ListItemButton onClick={() => toggleCriticite()} className={styles.pd4}>
                      <ListItemText primary="Criticité (3)" className={styles.sectionFilters} />
                      {openCritList ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openCritList} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {[0, 1, 2].map((value) => {
                          const labelIdCrit = `checkbox-list-label-${value}`;

                          return (
                            <ListItem key={value} disablePadding>
                              <ListItemButton role={undefined} onClick={() => handleClickCheckboxCrit(value)} className={styles.nestedList}>
                                <ListItemIcon className={styles.customCheckBox}>
                                  <Checkbox
                                    edge="start"
                                    checked={checkedCrit.indexOf(value) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                      "aria-labelledby": labelIdCrit
                                    }}
                                  />
                                </ListItemIcon>
                                {value === 0 && <ListItemText id={labelIdCrit} primary={`(niv.${value + 1}) Infos`} />}
                                {value === 1 && <ListItemText id={labelIdCrit} primary={`(niv. ${value + 1}) Alertes`} />}
                                {value === 2 && <ListItemText id={labelIdCrit} primary={`(niv. ${value + 1} et +) Erreurs`} />}
                              </ListItemButton>
                            </ListItem>
                          );
                        })}
                      </List>
                    </Collapse>
                  </List>
                </div>
              </div>
            </ReflexElement>

            <ReflexElement minSize={400} size={900} className={styles.listBlock}>
              <div className={styles.dataGridContainer}>
                {result.status !== "fulfilled" && result.status !== "uninitialized" && result.status !== "rejected" && (
                  <>
                    <Spinner />
                  </>
                )}

                {(result.status === "fulfilled" || result.status === "uninitialized") && (
                  <>
                    <div
                      style={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column"
                      }}
                    >
                      <div
                        style={{
                          padding: "8px 10px 4px 10px",
                          textAlign: "right",
                          flexShrink: 0
                        }}
                      >
                        <TextField
                          variant="standard"
                          value={searchText}
                          onChange={(event) => {
                            requestSearch(event.target.value);
                          }}
                          placeholder="Rechercher"
                          InputProps={{
                            startAdornment: <SearchIcon fontSize="small" />,
                            endAdornment: searchText && (
                              <IconButton title="Clear" aria-label="Clear" size="small" onClick={() => requestSearch("")}>
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            )
                          }}
                        />
                      </div>
                      <div style={{ flex: 1, minHeight: 0, marginBottom: "-8px" }}>
                        <DataGrid
                          initialState={{
                            sorting: {
                              sortModel: [{ field: "id", sort: "desc" }]
                            }
                          }}
                          headerHeight={35}
                          rows={rows}
                          rowHeight={40}
                          paginationModel={{
                            page: currentPage,
                            pageSize: pageSize
                          }}
                          onPaginationModelChange={(model) => {
                            setCurrentPage(model.page);
                            setPageSize(model.pageSize);
                          }}
                          pageSizeOptions={[20, 50, 100]}
                          columns={columns}
                          onRowClick={(params, event) => {
                            setSelectedRow(params.row);
                            setSelection([params.row.id]);
                          }}
                          onRowSelectionModelChange={(newSelection) => {
                            setSelection(newSelection);
                          }}
                          checkboxSelection={false}
                          disableRowSelectionOnClick={false}
                          sx={{
                            height: "100%",
                            "& .MuiDataGrid-footerContainer": {
                              marginBottom: 0,
                              paddingBottom: 0
                            }
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </ReflexElement>

            <ReflexElement minSize={200} size={650} className={styles.detailsBlock}>
              <div className={styles.detailsContent}>
                {selection.length !== 0 && (
                  <>
                    <div className={styles.blockHeader}>
                      <h3>
                        <PrivacyTipIcon className={styles.adjustPos} />
                        Détails
                      </h3>
                    </div>
                    <div className={styles.detailsInfo}>
                      <p>
                        <strong>id:</strong> {selectedRow.id}
                      </p>
                      <p>
                        <strong>Date de création:</strong>
                        <br />
                        {selectedRow.created_at}
                      </p>
                      <p>
                        <strong>Environnement:</strong>
                        <br />
                        {selectedRow.environment}
                      </p>
                      <p>
                        <strong>Service:</strong>
                        <br /> {selectedRow.service}
                      </p>
                      <p>
                        <strong>Criticité:</strong> {selectedRow.criticite}
                      </p>
                      <p>
                        <strong>Message:</strong>
                        <br />
                        {selectedRow.message}
                      </p>
                      <p>
                        <strong>StatusCode:</strong> {selectedRow.code}
                      </p>
                      <p>
                        <strong>ClassName:</strong>
                        <br />
                        {selectedRow.class_name}
                      </p>
                      <p>
                        <strong>Adresse IP:</strong> {selectedRow.ip}
                      </p>
                      <p>
                        <strong>Email Utilisateur:</strong>
                        <br />
                        {selectedRow.user_email}
                      </p>
                      <p>
                        <strong>Bearer Token:</strong>
                        <br />
                        {selectedRow.token}
                      </p>
                      <p>
                        <strong>Second Token:</strong>
                        <br />
                        {selectedRow.token2}
                      </p>
                    </div>
                  </>
                )}

                {selection.length === 0 && (
                  <>
                    <div className={styles.blockHeader}>
                      <h3>
                        <PrivacyTipIcon className={styles.adjustPos} />
                        Détails
                      </h3>
                    </div>
                    <div className={styles.detailsInfo}>
                      <p>
                        <strong>id:</strong>
                      </p>
                      <p>
                        <strong>Date de création:</strong>
                        <br />
                      </p>
                      <p>
                        <strong>Environnement:</strong>
                        <br />
                      </p>
                      <p>
                        <strong>Service:</strong>
                        <br />
                      </p>
                      <p>
                        <strong>Criticité:</strong>
                      </p>
                      <p>
                        <strong>Message:</strong>
                        <br />
                      </p>
                      <p>
                        <strong>StatusCode:</strong>
                      </p>
                      <p>
                        <strong>ClassName:</strong>
                        <br />
                      </p>
                      <p>
                        <strong>Adresse IP:</strong>
                      </p>
                      <p>
                        <strong>Email Utilisateur:</strong>
                        <br />
                      </p>
                      <p>
                        <strong>Bearer Token:</strong>
                        <br />
                      </p>
                      <p>
                        <strong>Second Token:</strong>
                        <br />
                      </p>
                    </div>
                  </>
                )}
              </div>
            </ReflexElement>
          </ReflexContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StoredLog;
